// import { config } from 'state/attributeGroup/config'
import { AttributeGroup } from 'state/attributeGroup'
import { Attribute } from 'state/attribute'
// import { Color } from 'state/color'
import 'state/attributeGroup/events'
import { classList } from 'MK/DOM/fns/classList'

const clearAttributes = () => {
  console.log('Clearing attributes.')
  // Hide group container prior to DOM manipulation.
  !classList.has(AttributeGroup.container, 'hide') && classList.add(AttributeGroup.container, 'hide')

  // Clear existing DOM nodes.
  while (AttributeGroup.container.firstChild) {
    AttributeGroup.container.removeChild(AttributeGroup.container.firstChild)
  }
  // console.log('AttributeGroup.container', AttributeGroup.container)

  // AttributeGroup.groups.filter(group => group.is.active).forEach(group => group.syncWithDOM())

  // classList.remove(refinementFilters, 'hide')
  classList.remove(AttributeGroup.container, 'hide')
}

MK.events.on('attribute:groups:initialize', (event = {}) => {
  const index = event.target


  try {
    if (!index.attributeGroups || index.attributeGroups.length === 0) {
      return
    }
    console.log('DEBUG (attribute:groups:initialize): Attempting attribute initialization.', index.attributeGroups)


    MK.events.emit('color:aliases:initialize', {
      initiator: 'attribute:groups:initialize'
    })

    clearAttributes()

    AttributeGroup.groups = index.attributeGroups.map(group => new AttributeGroup(group))


    if (MK.page.type === 'attribute' && AttributeGroup.groups && AttributeGroup.groups.length > 0) {
      // let selectedGroup = AttributeGroup.groups.find(group => group.id === `${MK.page.ids.group}`)
      let selectedGroup = AttributeGroup.groups.find(group => group.name === `${MK.page.ids.groupName}`)
      console.log('Selected Group:', selectedGroup)
      if (selectedGroup) {
        Attribute.selections.container.innerHTML = ''

        // let selectedAttribute = selectedGroup.attributes.find(attribute => attribute.nameLeftNav === MK.page.nameLeftNav)
        // let selectedAttribute = selectedGroup.attributes.find(attribute => `${attribute.alias}` === `${MK.page.ids.alias}`)
        let selectedAttribute = selectedGroup.attributes.find(attribute => window.location.href.includes(attribute.path))
        console.log('selectedAttribute:', selectedAttribute)
        if (selectedAttribute) {
          let clearAllLink = document.getElementById('clear-all-link')
          clearAllLink && clearAllLink.removeAttribute('style')


          MK.events.emit('attribute:toggle', {
            target: selectedAttribute,
            property: 'selected',
            value: true
          })
          // selectedAttribute.toggle('selected', true)
        } else {
          console.log('DEBUG (attribute:groups:initialize): Unable to identify selected attribute.', selectedGroup)
          let parentPathname = window.MK && window.MK.page && window.MK.page.url && window.MK.page.url.parent
          // console.log(parentPathname)
          parentPathname && MK.events.emit('redirect', {
            pathname: parentPathname
          })
        }
      }


    }
  } catch (error) {
    console.log('!!! ERROR (attribute:groups:initialize) Error during attribute group initialization.')
    console.log(error)
    MK.captureException(error)
  }

  try {
    // AttributeGroup.updateDOM()

    MK.events.emit('attribute:groups:updateDOM', {
      initiator: 'attribute:groups:initialize'
    })
  } catch (error) {
    console.log('!!! ERROR (attribute:groups:initialize) Error adding attribute groups to DOM.')
    console.log(error)
    MK.captureException(error)
  }

  try {
    AttributeGroup.addEventListeners()
  } catch (error) {
    console.log('!!! ERROR (attribute:groups:initialize) Error adding attribute groups event listeners.')
    console.log(error)
    MK.captureException(error)
  }


  // console.log(`DEBUG (attribute:groups:initialize): Attribute group initialization took  ${(performance.now() - start)} milliseconds.`)
  console.log(`DEBUG (attribute:groups:initialize): Attribute Groups: ${Object.keys(AttributeGroup.groups).length}`)

})